<style lang="less" scoped>
@import "./index.less";
</style>

<template>
  <div class="car-plate-binding">
    <van-index-bar>
      <template v-for="item in brand">
        <van-index-anchor :index="item.brand_ename" />
        <div v-for="innerItem in item.children" class="item" @click="selectBrand(innerItem)">
          <img :src="innerItem.brand_img" alt="" srcset="">
          <span>{{ innerItem.brand_name }}</span>
        </div>
      </template>
    </van-index-bar>
  </div>
</template>

<script>

import { IndexBar, IndexAnchor } from 'vant'
export default {
  name: 'home',
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
  },
  data() {
    return {
      brand: [ ]
    }
  },

  methods: {
    getAllCarBrand() {
      this.$axios.post('/v3/u/carBrand/allBrand', {}).then(res => {
        const data = (res.data.data || []);
        this.brand = Array.from(new Set(data.map(x => x.brand_ename))).map(v => ({ brand_ename: v, children: data.filter(x => x.brand_ename === v) }))
      })
    },
    selectBrand(item){
      this.$store.commit('carBrandHandle', {carLogo:item.brand_img,carBrandName:item.brand_name})
      this.$router.push({name:"carModel",query:{brand_id:item.brand_id}});
    }
  },
  created() {
    this.getAllCarBrand()
  }
}
</script>
